<ion-infinite-scroll threshold="100px" (ionInfinite)="loadData($event)"  *ngIf="totalRecordPages > 0">
  <ion-infinite-scroll-content
  loadingSpinner="bubbles"
    loadingText="Loading...">
  </ion-infinite-scroll-content>
</ion-infinite-scroll>
<!-- <h1>{{totalRecordPages}}</h1> -->